import { useMutation } from '@tanstack/react-query';

import { ConnectPageData, PLATFORM_URL_SEGMENT } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const connectPage = (data: ConnectPageData): Promise<void> => {
  return axios.post(`/${PLATFORM_URL_SEGMENT[data.platform]}/pages/connect`, data);
};

type ConnectPageOptions = {
  config?: MutationConfig<typeof connectPage>;
};

export function useConnectPage({ config = {} }: ConnectPageOptions = {}) {
  return useMutation({
    ...config,
    onSuccess: (...args) => {
      queryClient.invalidateQueries(['pages']);
      config.onSuccess?.(...args);
    },
    mutationFn: connectPage,
  });
}
